import { useMutation, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { api, getQueryProps, isTruthy, parseError, useToast } from 'common';

export function useApiFlowDefinition() {
  const { flowDefinitionId } = useParams<{ flowDefinitionId: string }>();
  const toast = useToast();
  const flowDefinitionResponse = useQuery({
    ...getQueryProps(api.client.FlowDefinition, 'findOneById', flowDefinitionId),
    enabled: isTruthy(flowDefinitionId),
  });

  const flowDefinitionMutation = useMutation({
    mutationFn: async (
      flowDefinitionAndId: { id: string } & api.FlowDefinition.UpdateValuesWithFlow
    ) => {
      const { id, ...flowDefinition } = flowDefinitionAndId;
      return await api.client.FlowDefinition.update(id, flowDefinition);
    },
    onSuccess: async () => {
      await flowDefinitionResponse.refetch();
    },
    onError: (error) => {
      toast.showError(parseError(error, 'Failed to update flow definition'));
    },
  });
  const { mutateAsync: updateFlowDefinition } = flowDefinitionMutation;
  return {
    flowDefinitionResponse,
    flowDefinitionMutation,
    updateFlowDefinition,
  };
}
